// extracted by mini-css-extract-plugin
export var active = "_ds-7";
export var blink = "_ds-8";
export var dropDownSelector = "_ds-4";
export var dropDownWrapper = "_ds-3";
export var fakeCursor = "_ds-6";
export var fontSizeButton = "_ds-9";
export var formQuillEditor = "_ds-0";
export var pressed = "_ds-a";
export var qlBlank = "_ds-1";
export var textFormattingToolbar = "_ds-2";
export var textToolbarOption = "_ds-5";